module.exports = __webpack_public_path__ + "images/Braille_ec869ef.png";